import axios from 'helpers/axios';

export const authenticateRequest = (username: string, password: string) => {
    return axios.post('/api/authentication/token/', { username, password });
};
